import React, { useCallback, useState, useEffect, useReducer } from 'react'
import { Select, Button, Table, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { store } from "@root/store/index";
import { getHelpObject, setHelpObject, setHelpSubmit } from "@root/common/service";
import '../_index.scss'

const { Option } = Select;
interface DataType {
  key: number|string;
  submitStatus: number|string; // 上报状态 0未上报  1已上报
  confirmStatus: number|string; // 支援医院确认状态 0通过 1拒绝 2未确认 
  returnReason: string; // 退回原因
  recipientInstituteName: string;  // 受援(县)医院名称
  supportInstituteName: string;  // 支援医院名称
  isEdit: any;  // 学科
  subjectList: string;  // 学科
}
function HelpObject() {

  const columns: ColumnsType<DataType> = [
    {
      title: '上报状态',
      dataIndex: 'submitStatus',
      key: 'submitStatus',
      width: 80,
      render: (_, a) => (
        <>
        {(()=>{
          if(a.submitStatus === 0){
            return ( <span style={{color: '#43cf7c'}}>未上报</span> )
          }else if(a.submitStatus === 1){
            return ( <span style={{color: '#ff8d1a'}}>已上报</span> )
          }
        })()}
        </>
      ),
    },
    {
      title: '支援医院确认状态',
      dataIndex: 'confirmStatus',
      key: 'confirmStatus',
      width: 80,
      render: (_, a) => (
        <>
        {(()=>{
          if(a.confirmStatus === '0'){
            return ( <span style={{color: '#2a82e4'}}>已确认</span> )
          }else if(a.confirmStatus === '2'){
            return ( <span style={{color: '#ff8d1a'}}>待确认</span> )
          }else{
            return ( <span style={{color: '#ff5733'}}>退回修改</span> )
          }
        })()}
        </>
      ),
    },
    {
      title: '退回原因',
      dataIndex: 'returnReason',
      key: 'returnReason',
    },
    {
      title: '县医院名称',
      dataIndex: 'recipientInstituteName',
      key: 'recipientInstituteName',
      width: 200,
    },
    {
      title: '支援医院名称',
      dataIndex: 'supportInstituteName',
      key: 'supportInstituteName',
      width: 200,
    },
    {
      title: '选择对应学科',
      dataIndex: 'subjectList',
      key: 'key',
      width: 200,
      render: (_,e)=> (
        <div key={e.key}>
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%' }}
            disabled={e.isEdit || e.submitStatus===1}
            defaultValue={(e.subjectList?.length===0) ? (undefined) : (e.subjectList?.split(',').map(Number))}
            onChange={handleChange}      
          >
            {subjectIdArr.map((e: any, i: number)=>{
              return <Option value={e.id} key={i}>{e.name}</Option>
            })} 
          </Select>
        </div>
      ),
    },
    {
      title: '操作',
      dataIndex: 'set',
      key: 'key',
      width: 50,
      render: (_,e)=> (
        <Button style={{padding: '0'}} disabled={e.submitStatus===1} onClick={()=>setObject(e)} type="link">{e.isEdit || e.submitStatus===1? '编辑' : '保存'}</Button>
      ),
    },
  ];

  const [data, setData] = useState<DataType[]>();
  // const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState<any>([]);
  const [subjectIdArr, setSubjectIdArr] = useState<any>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const getAll = async()=>{
    const {data: a} = await getHelpObject(`type=1`)
    a.forEach((e: any)=>{
      e.key = e.id
      e.isEdit = e.submitStatus === 0 ? true : false
    })
    setData(a)
  }
  useEffect(()=>{
    console.log(store.getState());    
    setSubjectIdArr(store.getState().directionaries.subjectData)
    getAll()
  },[])

  const handleChange = useCallback((e: any)=>{
    console.log(e);
    setEditData(e)
  },[])
  const setObject = useCallback((e: any)=>{
    console.log(e.isEdit,isEdit);
    e.isEdit = !e.isEdit
    setIsEdit(!isEdit)
    if(e.isEdit === false){
      console.log(e);
    }else{
      const setOne = async()=>{
        const {msg} =  await setHelpObject({
          id: e.id,
          subjectList: editData
        })
        message.success(msg);
        getAll()
      }
      setOne()
    }
  },[isEdit,editData])

  const start = useCallback((e: boolean) => {
    // setLoading(true);
    console.log(selectedRowKeys);    
    const setSubmint = async()=>{
      const {code,msg} = await setHelpSubmit({
        ids: selectedRowKeys.join(),
        status: e
      })
      if(code === 200){
        message.success(`${msg}`);
        getAll()
      }else{
        message.error(`${msg}`);
      }
    }
    setSubmint()
  },[selectedRowKeys])
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  // console.log('selectedRowKeys changed: ', selectedRowKeys);
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  return (
    <div>
      <div className='midBtn'>
        <Button type="primary" onClick={()=>start(true)} disabled={!hasSelected}>确认上报</Button>
        <Button type="primary" onClick={()=>start(false)} disabled={!hasSelected}>取消上报</Button>
      </div>

      <div>
        <Table size='middle' rowSelection={rowSelection} columns={columns} dataSource={data} />
      </div>
    </div>
  )
}

export default HelpObject